import MoreThing from '@/layouts/MoreThing/MoreThing';

export default MoreThing;
